<template>
  <component :is="as" :class="computedClasses" :style="computedRatio">
    <slot />
  </component>
</template>

<script setup lang="ts">
import { useCssModule } from 'vue'
const $style = useCssModule()

const props = withDefaults(
  defineProps<{
    ratio?: string
    as?: string
    inlineBlock?: boolean
  }>(),
  {
    ratio: '1x1',
    as: 'div',
    inlineBlock: false,
  },
)

const computedRatio = computed(() => {
  let widthFactor = 1
  let heightFactor = 1
  if (typeof props.ratio === 'string') {
    const [width, height] = props.ratio.split('x')
    widthFactor = parseInt(width)
    heightFactor = parseInt(height)
  }
  return `--aspect-ratio: ${widthFactor} / ${heightFactor};`
})

const computedClasses = computed(() => ({
  [$style.wrap]: true,
  [$style.inlineBlock]: props.inlineBlock,
}))
</script>

<style lang="scss" module>
.wrap {
  aspect-ratio: var(--aspect-ratio);
  overflow: var(--aspect-ratio-overflow, hidden);

  &.inlineBlock {
    display: inline-block;
  }

  picture,
  img {
    width: 100%;
    height: 100%;
  }

  img {
    object-fit: cover;
  }
}
</style>
